module.exports = __webpack_public_path__ + "4345a403db368d770d8c0f2ffec1c00b.svg";